import React from "react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white py-16" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate">
        <p className="text-xs uppercase tracking-[0.2em] text-[#00C853] font-semibold">Legal</p>
        <h1 className="font-display text-4xl font-bold text-[#0B3C5D] tracking-tight">Privacy Policy</h1>
        <p className="text-sm text-slate-500">Last updated: {new Date().toLocaleDateString()}</p>

        <h2 className="font-display text-[#0B3C5D]">1. Information We Collect</h2>
        <p>We collect information that you provide directly (name, email, country, phone), information about transactions (gift card details, payout methods), and technical data (IP address, device fingerprint) to prevent fraud.</p>

        <h2 className="font-display text-[#0B3C5D]">2. How We Use Information</h2>
        <ul>
          <li>To verify your identity and process payouts.</li>
          <li>To detect and prevent fraud, including AI-driven risk scoring.</li>
          <li>To comply with regulatory and AML/KYC requirements.</li>
          <li>To communicate with you about your transactions and product updates.</li>
        </ul>

        <h2 className="font-display text-[#0B3C5D]">3. Data Security</h2>
        <p>Card data is encrypted in transit (TLS 1.3) and at rest (AES-256). Gift card numbers are masked in our database — we never store the full unmasked card number after verification.</p>

        <h2 className="font-display text-[#0B3C5D]">4. Sharing of Information</h2>
        <p>We do not sell your data. We share information with payment processors, fraud-prevention vendors, and law enforcement only when legally required.</p>

        <h2 className="font-display text-[#0B3C5D]">5. Cookies</h2>
        <p>We use httpOnly cookies for authentication and analytics cookies (with consent) to improve our service.</p>

        <h2 className="font-display text-[#0B3C5D]">6. Your Rights</h2>
        <p>You have the right to access, correct, or delete your personal data and to opt out of marketing communications. Contact <a className="text-[#00C853]" href="mailto:privacy@giftopay.com">privacy@giftopay.com</a> to exercise these rights.</p>

        <h2 className="font-display text-[#0B3C5D]">7. International Transfers</h2>
        <p>Your data may be processed in the US, UK, UAE, or Canada. We apply appropriate safeguards for cross-border transfers.</p>

        <h2 className="font-display text-[#0B3C5D]">8. Retention</h2>
        <p>Transaction records are retained for at least 5 years to meet AML obligations. Inactive accounts may be deleted after 24 months.</p>

        <h2 className="font-display text-[#0B3C5D]">9. Children</h2>
        <p>Giftopay is not intended for users under 18.</p>

        <h2 className="font-display text-[#0B3C5D]">10. Changes</h2>
        <p>We may update this Policy. Material changes will be communicated via email or in-app notice.</p>
      </div>
    </div>
  );
}
